import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { HttpService } from '../shared/services/http.service';
import { SiteId } from '../site-detail/models/Site';

import { VideoCall, VideoCallId } from './models/video-call';

@Injectable({ providedIn: 'root' })
export class VideoCallsGateway {
    private readonly http = inject(HttpService);

    list(): Promise<VideoCall[]> {
        return firstValueFrom(this.http.get('/v1/video-calls'));
    }

    /** The response has no `siteId`: it is the installation the call was started for. */
    async start(siteId: SiteId): Promise<VideoCall> {
        const videoCall = await firstValueFrom(this.http.post(`/v1/video-call/${siteId}`, {}));
        return { ...videoCall, siteId };
    }

    async stop(siteId: SiteId): Promise<void> {
        await firstValueFrom(this.http.delete(`/v1/video-call/${siteId}`));
    }

    resend(videoCallId: VideoCallId): Promise<VideoCall> {
        return firstValueFrom(this.http.post(`/v1/video-call-resend/${videoCallId}`, {}));
    }
}
